// extracted by mini-css-extract-plugin
module.exports = {"btn":"UploadBtn_btn__YD4kO","text":"UploadBtn_text__3UVYg","img":"UploadBtn_img__1NhoR","hidden":"UploadBtn_hidden__UCvzs"};